import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
// 
class Trade_mission extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />


                <div
                    className="breadcrumb-wrapper bg-cover"
                    style={{ backgroundImage: 'url("assets/img/breadcrumb.jpg")' }}
                >
                    <div className="border-shape">
                        <img src="assets/img/element_1.png" alt="shape-img" />
                    </div>
                    <div className="line-shape">
                        <img src="assets/img/line-element.png" alt="shape-img" />
                    </div>
                    <div className="container">
                        <div className="page-heading">
                            <h1 className="wow fadeInUp" data-wow-delay=".3s">
                                Trade Missions
                            </h1>
                            <ul className="breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                                <Link to='/'><li>Home </li></Link>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Services</li>
                                <li>
                                    <i className="fa fa-chevron-right" />
                                </li>
                                <li>Trade Missions</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <section
                    className="about-section section-padding fix bg-cover"
                    style={{ backgroundImage: 'url("assets/img/service/service-bg-2.jpg")' }}
                >
                    <div className="container">
                        <div className="about-wrapper style-2">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="about-image-items">
                                        <div className="circle-shape">
                                            <img src="assets/img/about/circle.png" alt="shape-img" />
                                        </div>
                                        <div
                                            className="about-image-1 bg-cover wow fadeInLeft"
                                            data-wow-delay=".3s"
                                            style={{ backgroundImage: 'url("assets/img/Inbound_img.png")' }}
                                        >
                                            <div className="about-image-2 wow fadeInUp" data-wow-delay=".5s">
                                                <img src="assets/img/outbound_img.jpg" alt="about-img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 mt-4 mt-lg-0">
                                    <div className="about-content">
                                        <div className="section-title mb-3 mxw-650">
                                            <div className="subtitle">
                                                {" "}
                                                <img src="assets/img/icon/arrowLeft.svg" alt="icon" />{" "}
                                                <span>Trade Missions</span>
                                                <img src="assets/img/icon/arrowRight.svg" alt="icon" />
                                            </div>
                                            <h2 className="title">Inbound &amp; Outbound Services</h2>
                                        </div>
                                        <p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                                            The trade missions are designed to connect businesses with global
                                            opportunities. Inbound missions bring international businesses to
                                            India, providing them with valuable insights into the local market
                                            and facilitating meaningful partnerships with Indian companies.
                                            Outbound missions take Indian businesses abroad, helping them
                                            explore new markets, meet potential partners, and expand their
                                            global presence. Each mission is carefully curated to ensure
                                            productive engagement and long-term growth for participants.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <Footer />
            </>
        )

    }
}
// ReactDOM.render(<Homepage />, document.querySelector('.demo-carousel'))

export default withRouter(connect(null, {})(Trade_mission));